import { connect } from 'react-redux';
import  GoogleAnalytics4View from './GoogleAnalytics4View.jsx'
import { fetchIntegrations, getIntegrationForType } from "src/legacy/redux/actions/integrations.jsx";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'google_analytics_4');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }

  }
}

const GoogleAnalytics4Page = connect(
    mapStateToProps,
    mapDispatchToProps
)(GoogleAnalytics4View);

export default withUseHooks(GoogleAnalytics4Page);